import { render, staticRenderFns } from "./CurrentVersion.vue?vue&type=template&id=78ad31c0&scoped=true&"
import script from "./CurrentVersion.vue?vue&type=script&lang=js&"
export * from "./CurrentVersion.vue?vue&type=script&lang=js&"
import style0 from "./CurrentVersion.vue?vue&type=style&index=0&id=78ad31c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ad31c0",
  null
  
)

export default component.exports